import {useState, useEffect} from 'react';
import { FormGroup, Label, Input } from 'reactstrap'

import { isNull } from '../../izUtils';
import DisplayHistory from '../../helpers/DisplayHistory';
import DictionaryInfoButton from '../dictionary/DictionaryInfoButton';

const TextArea = ({data, onChange, onBlur, showErrors, history, showDictionary}) => {
    const { type, name, display, errors, title, disabled, mandatory} = data;

    const [value, setValue] = useState("");

    useEffect(() => {
        setValue(data.value === null ? '' : data.value);
    }, [data.value]);

    const handleChange = (e) => {
        setValue(e.target.value);
    };

    if (display) {
        return (
            <FormGroup className={(data.name === 'reject_message') ? 'red-alert' : ''}>
                <div className="d-flex align-items-center">
                    <Label>{title + (mandatory ? " *" : "")}</Label>
                    {(showDictionary && showDictionary.fields?.includes(name)) &&
                            <DictionaryInfoButton code={`${showDictionary.form}.form.${name}`} id={`${showDictionary.form}.form.${name}`} marginBottom="0.2rem" />
                    }
                </div>
                <Input
                    type={type}
                    className={"form-control"}
                    rows="4"
                    id={name}
                    value={value}
                    disabled={disabled}
                    onChange={handleChange}
                    onBlur={() => isNull(onBlur) ? {} : onBlur(value, name)}
                />
                {!isNull(showErrors) && showErrors && !isNull(errors) && errors.length !== 0 && <div style={{ color: "red", marginBottom: "10px" }}>{errors.map((error, index) => <div key={"error-"+index}>{error}</div>)}</div>}
                {(!isNull(history) && history.length > 0) && <DisplayHistory history={history} data={data} />}
            </FormGroup>
        )
    } else {
        return null;
    }
}

export default TextArea